import { defineFormConfig } from "@src/components/business-form";
import type { OnsideInvoiceContentConfirmLeaveParams } from "../../../../../../api/onsideInvoices";

/** Значения формы подтверждения отгрузки строки НС (полей ввода нет). */
export type StockFinishedGoodsShipmentContentFormValues = Record<string, never>;

/** Контекст формы подтверждения отгрузки строки НС. */
export interface StockFinishedGoodsShipmentContentFormContext {
    /** Код строки состава НС. */
    contentCode: number;
    /** Целевое значение признака подтверждения выдачи при submit. */
    confirmLeave: boolean;
}

/** Конфигурация формы подтверждения отгрузки строки НС. */
export const stockFinishedGoodsShipmentContentFormConfig = defineFormConfig<
    StockFinishedGoodsShipmentContentFormValues,
    OnsideInvoiceContentConfirmLeaveParams,
    StockFinishedGoodsShipmentContentFormContext
>({
    fields: {},
    toDomainOverride: (_values, { context }) => {
        if (context == null) {
            return {
                code: 0,
                confirmLeave: false,
            };
        }

        return {
            code: context.contentCode,
            confirmLeave: context.confirmLeave,
        };
    },
});
